import React from "react";

// The brand mark — a stylized "Z" prism that doubles as a lightning bolt.
// Simple SVG so it works everywhere (favicon, nav, loaders).
export const Logo = ({ className = "", size = 28, showText = true }) => {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="z-grad" x1="12" y1="14" x2="52" y2="50" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFD399" />
            <stop offset="0.55" stopColor="#FF9E00" />
            <stop offset="1" stopColor="#D97706" />
          </linearGradient>
          <filter id="z-glow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="1.2" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <rect x="1" y="1" width="62" height="62" rx="14" stroke="url(#z-grad)" strokeOpacity="0.35" strokeWidth="1" fill="#0B0C10" />
        <path
          d="M18 20 L46 20 L22 44 L46 44"
          stroke="url(#z-grad)"
          strokeWidth="4.5"
          strokeLinecap="square"
          strokeLinejoin="miter"
          filter="url(#z-glow)"
        />
        <circle cx="46" cy="20" r="2.2" fill="#FFC266" />
        <circle cx="22" cy="44" r="2.2" fill="#FFC266" />
      </svg>
      {showText && (
        <span className="font-display font-semibold text-[15px] tracking-tight text-[#F4F4F2]">
          Z Crazy<span className="text-accent">.</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
